/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-test-item.reducer';

export const LabTestItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labTestItemEntity = useAppSelector(state => state.labTestItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labTestItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labTestItem.detail.title">LabTestItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labTestItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.id}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labTestItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.labTestItem.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.lastupdated}</dd>
          <dt>
            <span id="measurement">
              <Translate contentKey="tinyMedicRestApp.labTestItem.measurement">Measurement</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.measurement}</dd>
          <dt>
            <span id="methodName">
              <Translate contentKey="tinyMedicRestApp.labTestItem.methodName">Method Name</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.methodName}</dd>
          <dt>
            <span id="sortOrder">
              <Translate contentKey="tinyMedicRestApp.labTestItem.sortOrder">Sort Order</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.sortOrder}</dd>
          <dt>
            <span id="testLocalAbbrev">
              <Translate contentKey="tinyMedicRestApp.labTestItem.testLocalAbbrev">Test Local Abbrev</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.testLocalAbbrev}</dd>
          <dt>
            <span id="testName">
              <Translate contentKey="tinyMedicRestApp.labTestItem.testName">Test Name</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.testName}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.labTestItem.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labTestItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.microSec}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labTestItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.cursor}</dd>
          <dt>
            <span id="sample">
              <Translate contentKey="tinyMedicRestApp.labTestItem.sample">Sample</Translate>
            </span>
          </dt>
          <dd>{labTestItemEntity.sample}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItem.dataType">Data Type</Translate>
          </dt>
          <dd>{labTestItemEntity.dataType ? labTestItemEntity.dataType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItem.category">Category</Translate>
          </dt>
          <dd>{labTestItemEntity.category ? labTestItemEntity.category.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItem.catalog">Catalog</Translate>
          </dt>
          <dd>{labTestItemEntity.catalog ? labTestItemEntity.catalog.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labTestItem.testType">Test Type</Translate>
          </dt>
          <dd>{labTestItemEntity.testType ? labTestItemEntity.testType.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-test-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-test-item/${labTestItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabTestItemDetail;
